<ng-container *ngIf="question">
  <ng-container [ngSwitch]="question.field_type">
    <!-- TEXT FIELD -->
    <ng-container *ngSwitchCase="FieldTypes.TEXT">
      <ng-container *ngIf="viewState === viewStates.PREVIEW; else textInput">
        <div class="placeholder-text-input">
          <div class="handle"></div>
        </div>
      </ng-container>
      <ng-template #textInput>
        <input
          type="text"
          class="proforms-text-input"
          [formControl]="textControl" />
      </ng-template>
    </ng-container>

    <!-- TEXTAREA FIELD -->
    <ng-container *ngSwitchCase="FieldTypes.TEXTAREA">
      <ng-container
        *ngIf="viewState === viewStates.PREVIEW; else textareaInput">
        <div class="placeholder-textarea">
          <div class="handle"></div>
        </div>
      </ng-container>
      <ng-template #textareaInput>
        <textarea
          class="proforms-text-input proforms-text-input-textarea"
          [formControl]="textareaControl">
        </textarea>
      </ng-template>
    </ng-container>
  </ng-container>
</ng-container>
